<ms-font-resizer
    class="freebet-stake__value"
    *ngIf="freeBetToken"
    [value]="freeBetToken.amount | bsCurrency: true"
    [shouldSkipCustomStyling]="true"
    [defaultSize]="isLinear ? 1 : 0.875"
    [maxChars]="isEpcotEnabled ? 8 : 12" />
